import { type PageEntity, apiClient, type CustomerEntity } from '@/libs/api'
import { type CustomersListRequestQuery } from '@/libs/api/types'

export type FetchCustomersListQuery = {
  tenantKey: string
  query?: CustomersListRequestQuery
}

export type FetchCustomersListResponse = {
  data: CustomerEntity[]
  pagination: PageEntity | null
}

export const fetchCustomersList = async (
  { tenantKey, query }: FetchCustomersListQuery,
  signal?: AbortSignal
): Promise<FetchCustomersListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .customers.list.$get({
      query,
      config: {
        signal
      }
    })

  return {
    data,
    pagination
  }
}
